// extracted by mini-css-extract-plugin
export default {"p_tye":"_5e1d091c8d","slcted":"_29325c7770","slc_color":"_618d2e184d","item_p":"f7d3d9cd09","r0":"_4aef757eaf"};